export type GranolaNoteOutcome = 'tasks_created' | 'no_tasks' | 'no_client' | 'internal';

export type GranolaHealth = {
  webhookRegistered: boolean;
  lastNote: {
    title: string;
    meetingDate: string;
    outcome: GranolaNoteOutcome;
    receivedAt: string;
  } | null;
};

const OUTCOME_LABELS: Record<GranolaNoteOutcome, string> = {
  tasks_created: 'Tasks created',
  no_tasks: 'No tasks for you',
  no_client: 'Not matched to a client',
  internal: 'Internal meeting',
};

function shortDate(iso: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

// Settings and Admin describe the same connection, so they say it in the same
// words: a problem when notes cannot arrive, and what last did.
export function describeGranolaHealth(health: GranolaHealth): {
  problem: string | null;
  lastNote: string;
} {
  const note = health.lastNote;
  return {
    problem: health.webhookRegistered
      ? null
      : 'Webhook not registered, so meeting notes won’t arrive. Remove the key and add it again.',
    lastNote: note
      ? `Last note: ${note.title} (${shortDate(note.meetingDate)}) · ${OUTCOME_LABELS[note.outcome]}`
      : 'No meeting notes received yet',
  };
}
